import CareersCTA from "@/components/careers/cta";
import { Component } from "@builder.io/sdk";

export const careersCTAConfig: Component = {
  name: "Careers CTA",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "Join Our Team",
      helperText: "The main heading text displayed in the CTA section",
    },
    {
      name: "image",
      friendlyName: "Image",
      type: "object",
      defaultValue: {
        src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F47dc3ae7e57e4c0690095c3c47bab55a",
        alt: "Careers CTA Image",
      },
      subFields: [
        {
          name: "src",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
          required: true,
          friendlyName: "Image URL",
          helperText: "URL or path to the image",
        },
        {
          name: "alt",
          type: "string",
          required: true,
          friendlyName: "Alt Text",
          helperText: "Alt text for accessibility",
        },
        {
          name: "className",
          type: "string",
          advanced: true,
          friendlyName: "Image CSS Classes",
          helperText: "Optional CSS classes to apply to the image",
        },
      ],
    },
    {
      name: "cta",
      friendlyName: "Button CTA",
      type: "object",
      defaultValue: {
        text: "Apply Now",
        href: "#careers-application-form",
      },
      subFields: [
        {
          name: "text",
          type: "string",
          required: true,
          friendlyName: "Button Text",
          helperText: "Text to display on the CTA button",
        },
        {
          name: "href",
          type: "string",
          required: true,
          friendlyName: "Button URL",
          helperText: "URL that the button links to",
        },
      ],
    },
  ],
};

export default CareersCTA;
